'use client';

import { useEffect } from 'react';
import { datadogRum } from '@datadog/browser-rum';
import useStore from '@hooks/useStore';
import { useLeadStore } from '@stores';

const isProd = process.env.STAGE === 'pro';

if (isProd) {
  datadogRum.init({
    applicationId: process.env.NEXT_PUBLIC_DD_APPLICATION_ID,
    clientToken: process.env.NEXT_PUBLIC_DD_CLIENT_TOKEN,
    site: 'datadoghq.com',
    service: process.env.NEXT_PUBLIC_DD_SERVICE,
    env: process.env.STAGE,
    sessionSampleRate: 100,
    sessionReplaySampleRate: 20,
    trackUserInteractions: true,
    trackResources: true,
    trackLongTasks: true,
    defaultPrivacyLevel: 'mask-user-input',
  });
}

export default function DatadogInit() {
  const leadStore = useStore(useLeadStore, (state) => state);
  const isInitalized = leadStore?.isInitialized;
  const lead = leadStore?.lead;

  const user = {
    id: lead?.leadId || undefined,
    name: `${lead?.personalInformation?.name || ''} ${lead?.personalInformation?.surname || ''} ${
      lead?.personalInformation.secondSurname
    }`.trim(),
    rut: lead?.personalInformation?.rut || '',
    email: lead?.contactInformation?.email?.email || '',
  };

  useEffect(() => {
    if (!isInitalized || !isProd) return;

    datadogRum.onReady(() => {
      datadogRum.setUser(user);
    });
  }, [lead]);

  return null;
}
